import { Heading4, PrimaryButton, RootButton, SecondaryText, SupportText, getColor, getSize, styleVariables } from '@lib/common';
import { Button, PageHeader } from 'antd';
import styled from 'styled-components';
export var DetailHeader = styled.div.withConfig({
  displayName: "class-detailstyles__DetailHeader",
  componentId: "sc-193o14n-0"
})(["padding:12px 24px;border-bottom:1px solid ", ";"], getColor('fillIntSubActive'));
export var Root = styled.div.withConfig({
  displayName: "class-detailstyles__Root",
  componentId: "sc-193o14n-1"
})(["position:relative;display:flex;flex:1;flex-direction:column;min-height:0;width:100%;overflow:hidden;"]);
export var Main = styled.div.withConfig({
  displayName: "class-detailstyles__Main",
  componentId: "sc-193o14n-2"
})(["display:flex;flex:1;flex-direction:column;min-height:0;overflow:hidden;"]);
export var StyledPageHeader = styled(PageHeader).withConfig({
  displayName: "class-detailstyles__StyledPageHeader",
  componentId: "sc-193o14n-3"
})(["display:flex;padding:0;width:100%;.ant-page-header-heading-title{font-size:24px;}.ant-page-header-heading-left{height:min-content;align-items:center;}.ant-page-header-heading{flex:1;}"]);
export var ClassContent = styled.div.withConfig({
  displayName: "class-detailstyles__ClassContent",
  componentId: "sc-193o14n-4"
})(["flex:1;min-height:0;height:100%;display:", ";flex-direction:column;overflow:hidden;"], function (_ref) {
  var $active = _ref.$active;
  return $active ? 'flex' : 'none';
});
export var TabContent = styled.div.withConfig({
  displayName: "class-detailstyles__TabContent",
  componentId: "sc-193o14n-5"
})(["height:100%;padding:16px 24px;overflow-y:auto;"]);
export var Toolbar = styled.div.withConfig({
  displayName: "class-detailstyles__Toolbar",
  componentId: "sc-193o14n-6"
})(["display:flex;align-items:center;gap:12px;margin-bottom:20px;"]);
export var Search = styled.div.withConfig({
  displayName: "class-detailstyles__Search",
  componentId: "sc-193o14n-7"
})(["flex:1;max-width:520px;.ant-input-affix-wrapper{height:50px;border:1px solid ", ";border-radius:12px;padding:0 16px;}.ant-input-prefix{margin-right:12px;color:", ";font-size:18px;}"], styleVariables.colors.grey14, styleVariables.colors.gray10);
export var FilterWrapper = styled.div.withConfig({
  displayName: "class-detailstyles__FilterWrapper",
  componentId: "sc-193o14n-8"
})(["position:relative;display:inline-block;"]);
export var FilterTrigger = styled.button.withConfig({
  displayName: "class-detailstyles__FilterTrigger",
  componentId: "sc-193o14n-9"
})(["display:inline-flex;align-items:center;gap:8px;height:50px;padding:0 16px;border:1.5px solid ", ";border-radius:12px;background:", ";color:", ";font-size:14px;font-weight:600;cursor:pointer;"], styleVariables.colors.blue3, styleVariables.colors.blue1, styleVariables.colors.blue3);
export var FilterBadge = styled.span.withConfig({
  displayName: "class-detailstyles__FilterBadge",
  componentId: "sc-193o14n-10"
})(["display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:", ";color:#fff;font-size:11px;"], styleVariables.colors.blue3);
export var FilterPanel = styled.div.withConfig({
  displayName: "class-detailstyles__FilterPanel",
  componentId: "sc-193o14n-11"
})(["position:absolute;top:calc(100% + 8px);right:0;z-index:1000;min-width:220px;padding:12px 8px;border:1px solid ", ";border-radius:16px;background:", ";box-shadow:0 12px 32px rgba(0,0,0,0.12);"], styleVariables.colors.grey14, styleVariables.colors.gray1);
export var FilterTitle = styled.div.withConfig({
  displayName: "class-detailstyles__FilterTitle",
  componentId: "sc-193o14n-12"
})(["padding:12px 16px 8px;color:", ";font-size:13px;font-weight:700;text-transform:uppercase;"], styleVariables.colors.grey70);
export var FilterOption = styled.button.withConfig({
  displayName: "class-detailstyles__FilterOption",
  componentId: "sc-193o14n-13"
})(["display:flex;align-items:center;gap:12px;width:calc(100% - 16px);margin:2px 8px;padding:10px 12px;border:1px solid ", ";border-radius:10px;background:", ";color:", ";cursor:pointer;text-align:left;"], function (_ref2) {
  var $active = _ref2.$active;
  return $active ? styleVariables.colors.blue3 : 'transparent';
}, function (_ref3) {
  var $active = _ref3.$active;
  return $active ? styleVariables.colors.blue1 : 'transparent';
}, function (_ref4) {
  var $active = _ref4.$active;
  return $active ? styleVariables.colors.blue3 : styleVariables.colors.grey100;
});
export var FilterCheck = styled.span.withConfig({
  displayName: "class-detailstyles__FilterCheck",
  componentId: "sc-193o14n-14"
})(["margin-left:auto;opacity:", ";"], function (_ref5) {
  var $visible = _ref5.$visible;
  return $visible ? 1 : 0;
});
export var MemberList = styled.div.withConfig({
  displayName: "class-detailstyles__MemberList",
  componentId: "sc-193o14n-15"
})(["display:flex;flex-direction:column;"]);
export var MemberCard = styled.div.withConfig({
  displayName: "class-detailstyles__MemberCard",
  componentId: "sc-193o14n-16"
})(["display:flex;align-items:center;gap:20px;margin-bottom:16px;padding:16px 24px;border:1px solid ", ";border-radius:", ";background:", ";"], styleVariables.colors.gray9, getSize('radiusSm'), getColor('fillBgWhite'));
export var MemberInfo = styled.div.withConfig({
  displayName: "class-detailstyles__MemberInfo",
  componentId: "sc-193o14n-17"
})(["flex:1;display:flex;flex-direction:column;"]);
export var MemberName = styled(Heading4).withConfig({
  displayName: "class-detailstyles__MemberName",
  componentId: "sc-193o14n-18"
})([""]);
export var MemberEmail = styled(SecondaryText).withConfig({
  displayName: "class-detailstyles__MemberEmail",
  componentId: "sc-193o14n-19"
})(["margin-bottom:8px;"]);
export var MemberTime = styled(SupportText).withConfig({
  displayName: "class-detailstyles__MemberTime",
  componentId: "sc-193o14n-20"
})(["display:flex;align-items:center;gap:6px;"]);
export var MemberAction = styled.div.withConfig({
  displayName: "class-detailstyles__MemberAction",
  componentId: "sc-193o14n-21"
})(["display:flex;flex-direction:column;gap:8px;align-items:center;width:132px;flex-shrink:0;> button,.ant-popover-open{width:100%;}"]);
export var MemberRemoveButton = styled(RootButton).withConfig({
  displayName: "class-detailstyles__MemberRemoveButton",
  componentId: "sc-193o14n-22"
})(["width:100%;justify-content:center;padding-left:", ";padding-right:", ";font-size:", ";"], getSize('padding8'), getSize('padding8'), getSize('typo13'));
export var LoadMore = styled(Button).withConfig({
  displayName: "class-detailstyles__LoadMore",
  componentId: "sc-193o14n-23"
})(["align-self:center;margin-bottom:16px;"]);
export var ClassActionButton = styled(PrimaryButton).withConfig({
  displayName: "class-detailstyles__ClassActionButton",
  componentId: "sc-193o14n-24"
})(["display:inline-flex;align-items:center;justify-content:center;width:40px;min-width:40px;height:40px;padding:0 !important;.anticon{margin:0 !important;}"]);